// /pair — admin copy of the web app's src/device/PairScan.jsx (card 540f21a4,
// Devin 2026-10-25): a phone that scanned a device's QR code, signed in to
// the admin app, picks the event; its Event Devices screen opens with the
// code filled in. Signed out, /pair keeps the code and shows the sign-in,
// which comes back here (Organizer/Auth/LoginOrg.jsx).
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Msr, useMaterialSymbols } from '../Organizer/OireachtasPanel/symbols';
import { openEvents } from './deviceApi';
import { forgetPairCode, pairCodeFrom } from './pairCode';
import LoginOrg from '../Organizer/Auth/LoginOrg';
import '../Organizer/OireachtasPanel/oireachtas.css';
import '../Organizer/OireachtasPanel/organizerOireachtas.css';
import './pairScan.css';

// An ended sign-in (expired or invalid token): 401, or a 403 that says so.
const SESSION_ENDED = /session expired|invalid token|error finding user/i;
const sessionEnded = (e) => e.status === 401 || (e.status === 403 && SESSION_ENDED.test(String(e.message || '')));

const shown = (d) => (d ? `${d.slice(0, 3)}-${d.slice(3)}` : '');
const dayText = (day) =>
  day ? new Date(`${day}T12:00:00Z`).toLocaleDateString('en-CA', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }) : '';

// signed out: keep the code, then the usual sign-in
export const PairSignIn = () => {
  const location = useLocation();
  useState(() => pairCodeFrom(location.search));
  return <LoginOrg />;
};

const PairScan = () => {
  useMaterialSymbols();
  const navigate = useNavigate();
  const location = useLocation();
  const [code] = useState(() => pairCodeFrom(location.search));
  const [events, setEvents] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    openEvents(localStorage.getItem('accessToken'))
      .then((r) => setEvents(r.events || []))
      .catch((e) => {
        // an ended sign-in: drop it and come back through sign-in, the code
        // kept in sessionStorage (admin MC review 19252b8f R1-F1); a full load,
        // as the app picks its signed-out pages when it starts
        if (sessionEnded(e)) {
          localStorage.removeItem('accessToken');
          window.location.replace('/pair');
          return;
        }
        setError(e.offline ? 'No connection — check the network and try again.' : e.message);
      });
  }, []);

  const open = (ev) => {
    forgetPairCode();
    navigate(`/job-devices?id=${ev._id}${ev.kind === 'oireachtas' ? '&kind=oireachtas' : ''}&code=${code}`);
  };

  let body;
  if (!code) body = <p className="dp-error">This QR code has no pairing code in it. Scan the code on the device again.</p>;
  else if (error) body = <p className="dp-error">{error}</p>;
  else if (events === null) body = <p className="dp-hint">Loading events…</p>;
  else if (!events.length) {
    body = <p className="dp-hint">No event is open for pairing now. Devices can be paired from the day before an event until it ends.</p>;
  } else {
    body = (
      <>
        <p className="dp-hint">Which event is this device for?</p>
        <div className="dp-events">
          {events.map((ev) => (
            <button key={ev._id} type="button" className="dp-event" onClick={() => open(ev)}>
              <b>{ev.name}</b>
              <span>
                {ev.kind === 'oireachtas' ? 'Oireachtas' : 'Feis'} · {dayText(ev.day)}
              </span>
              <Msr>chevron_right</Msr>
            </button>
          ))}
        </div>
      </>
    );
  }

  return (
    <div className="oir dp-page">
      <main className="dp-card" aria-live="polite">
        <h1>Pair a device</h1>
        {code ? (
          <div className="dp-code dp-code-sm" data-testid="pair-code">
            {shown(code)}
          </div>
        ) : null}
        {body}
      </main>
    </div>
  );
};

export default PairScan;
